/**
 * Analytics Configuration Modal
 *
 * NOTE: The analytics-backend (Cube.js integration) has been removed.
 * This modal is preserved as a stub for backwards compatibility.
 */

import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface AnalyticsConfigurationModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectId?: string;
}

export const AnalyticsConfigurationModal: React.FC<AnalyticsConfigurationModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Feature Unavailable
          </DialogTitle>
          <DialogDescription>
            The analytics configuration feature is temporarily unavailable.
            The Cube.js analytics backend has been removed from this installation.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-muted-foreground">
            For data queries and visualization, please use the Data page which
            connects to your configured data sources.
          </p>
        </div>

        <DialogFooter>
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AnalyticsConfigurationModal;
